import React from "react";

import AppBar from './Components/AppBarComp/AppBarComp';
import Alerts from './Components/Alerts/Alerts';
import ModalComp from './Components/ModalComp/ModalComp';
import ButtonsComp from './Components/ButtonsComp/ButtonsComp';
import CheckBoxes from './Components/CheckBoxes/CheckBoxes';
import IconsComp from './Components/IconsComp/IconsComp';
import ProgressComp from './Components/ProgressComp/ProgressComp';
import ExpansionComp from './Components/ExpansionComp/ExpansionComp'
import SnackBarComp from './Components/SnackBarComp/SnackBarComp'
import SwitchComp from './Components/SwitchComp/SwitchComp'
import SliderComp from './Components/SliderComp/SliderComp'
import RadioComp from './Components/RadioComp/RadioComp'

import Main from './../../Layouts/Main/Main'

const UiMaterialCompRoutes = [
  {
    path: "/components/alerts",
    component: Alerts,
    layout: Main,
  },
  {
    path: "/components/appbar",
    component: AppBar,
    layout: Main,
  },
  {
    path: "/components/modal-dialog",
    component: ModalComp,
    layout: Main,
  },
  {
    path: "/components/buttons",
    component: ButtonsComp,
    layout: Main,
  },
  {
    path: "/components/checkboxes",
    component: CheckBoxes,
    layout: Main,
  },
  {
    path: "/components/icons",
    component: IconsComp,
    layout: Main,
  },
  {
    path: "/components/progress",
    component: ProgressComp,
    layout: Main,
  },
  {
    path: "/components/expansion",
    component: ExpansionComp,
    layout: Main,
  },
  {
    path: "/components/snackbar",
    component: SnackBarComp,
    layout: Main,
  },
  {
    path: "/components/switches",
    component: SwitchComp,
    layout: Main,
  },
  {
    path: "/components/sliders",
    component: SliderComp,
    layout: Main,
  },
  {
    path: "/components/radio-buttons",
    component: RadioComp,
    layout: Main,
  },

];

export default UiMaterialCompRoutes;
